import type { EditorState } from '@atlaskit/editor-prosemirror/state';
import { isExperimentEnabled } from '@atlaskit/platform-feature-experiments/is-experiment-enabled';

import { getHistoryEntryForUpdate } from '../../pm-plugins/remix-history/getHistoryEntryForUpdate';

/** Read only the selected object's history; missing metadata must never affect an edit. */
export const getInlineRemixMetadata = (
	editorState: EditorState | undefined,
	targetId: string | undefined,
): { remixSubtype?: string; remixType?: string } | undefined => {
	if (
		!isExperimentEnabled('maui_remix_feature_area_by_type_exp_gate') ||
		!editorState ||
		!targetId
	) {
		return undefined;
	}
	try {
		let metadata: { remixSubtype?: string; remixType?: string } | undefined;
		editorState.doc.descendants((node) => {
			if (metadata || node.attrs.localId !== targetId) {
				return metadata ? false : true;
			}
			const history = getHistoryEntryForUpdate({
				state: editorState,
				url: node.attrs.parameters?.macroParams?.url?.value,
				fieldId: node.type.name === 'mediaSingle' ? node.firstChild?.attrs.id : node.attrs.id,
			});
			if (history?.dynamicUiType) {
				metadata = { remixType: history.dynamicUiType, remixSubtype: history.dynamicUiSubtype };
			}
			return false;
		});
		return metadata;
	} catch {
		return undefined;
	}
};
